import React, { Fragment, useState } from "react";
// import { initializeApp } from 'firebase/app';
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
// import "react-phone-number-input/style.css";
import OtpInput from "otp-input-react";

import { auth } from "../config/firebase.config";
import { useDispatch } from "react-redux";
import { register } from "../actions/userActions";
import { useSelector } from "react-redux";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useEffect } from "react";
import { USER_REGISTER_RESET } from "../constants/userConstants";
import Message from "../components/Message";
import {
  Button,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react";
import axios from "axios";
import { serverIp } from "../config/conf";
import { Dialog, Transition } from "@headlessui/react";
import { FaWhatsapp } from "react-icons/fa";


const RegistrationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    whatsapp: "",
    otpPhone: "",
    otpEmail: "",
    otpWhatsapp: "",
  });

  const [resendTimeout, setResendTimeout] = useState(30);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpVerifiedMail, setOtpVerifiedMail] = useState(false);
  const [error, setError] = useState("");
  const [idToken, setIdToken] = useState(null);
  const [uid, setUid] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [whatsappError, setWhatsappError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [isSameWhatsApp, setIsSameWhatsApp] = useState(false);

  const userRegister = useSelector((state) => state.userRegister);
  const { error: errorUSer, userInfo, success } = userRegister;


  useEffect(() => {
    if (otpSent && resendTimeout > 0) {
      const timer = setTimeout(
        () => setResendTimeout((prev) => prev - 1),
        1000
      );
      return () => clearTimeout(timer);
    } else if (resendTimeout === 0) {
      setOtpSent(false); // Re-enable the Send OTP button
      setResendTimeout(30); // Reset timer
    }
  }, [otpSent, resendTimeout]);

  useEffect(() => {

    if (userInfo?.success) {
      navigate("/signup");
    }
    dispatch({ type: USER_REGISTER_RESET });
  }, [navigate, userInfo]);


  const handleInputChange = (value, name) => {
    // setForm((prevForm) => ({ ...prevForm, [name]: value, whatsapp: isSameWhatsApp ? value : null }));
    setForm(prevForm => {
      const updatedForm = { ...prevForm, [name]: value };

      // if phone is updated & sameWhatsApp is true, keep whatsapp in sync
      if (name === "phone" && isSameWhatsApp) {
        updatedForm.whatsapp = value;
      } else if (updatedForm.whatsapp && updatedForm.whatsapp === updatedForm.phone) {
        setIsSameWhatsApp(true);
      } else if (updatedForm.whatsapp !== updatedForm.phone) {
        setIsSameWhatsApp(false);
      }

      return updatedForm;
    });
    if (name === "phone") {
      setPhoneError(isValidPhoneNumber(value) ? "" : "Invalid phone number");
    } else if (name === "email") {
      setEmailError(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? "" : "Invalid email"
      );
    } else if (name === "whatsapp") {

      setWhatsappError(
        validateWhatsappNumber(value) ? "" : "Invalid whatsapp number"
      );
    }
  };

  function closeModal() {
    setForm(prev => ({
      ...prev,
      otpPhone: "",
      otpEmail: "",
      otpWhatsapp: "",
    }));
    setIsOpen(false);
  }

  function setWhatsAppNumber(val) {
    if (val === true) {
      setIsSameWhatsApp(true);
      setForm(prev => ({
        ...prev,
        whatsapp: form.phone
      }));
    } else {
      setIsSameWhatsApp(false);
      setForm(prev => ({
        ...prev,
        whatsapp: ""
      }));
    }
    //  handleInputChange(e.target.value, "whatsapp");
    validateWhatsappNumber(form.whatsapp);
  }

  function openModal() {
    setIsOpen(true);
  }

  const validatePhoneNumber = (phone) => {

    // Check if input contains any alphabet character
    if (/[a-zA-Z]/.test(phone)) {
      setPhoneError("Alphabets are not allowed. Please enter digits only.");
      return false;
    }

    // Now check if it's exactly 10 digits
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number.");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const validateWhatsappNumber = (phone) => {
    if (!phone) {
      setWhatsappError("");
      return true; // Allow empty input
    }

    // Check if input contains any alphabet character
    if (/[a-zA-Z]/.test(phone)) {
      setWhatsappError("Alphabets are not allowed. Please enter digits only.");
      return false;
    }

    // Now check if it's exactly 10 digits
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setWhatsappError("Please enter a valid 10-digit WhatsApp number.");
      return false;
    }

    setWhatsappError("");
    return true;
  };

  // const sendOtp = async (e) => {
  //   e.preventDefault();
  //   setOtpLoading(true);
  //   setError("");

  //   // Validation
  //   if (!validatePhoneNumber(form.phone) || !validateEmail(form.email)) {
  //     setError("Please enter a valid phone and email");
  //     setOtpLoading(false);
  //     return;
  //   }

  //   // Initialize reCAPTCHA if needed
  //   if (!window.recaptchaVerifier) {
  //     window.recaptchaVerifier = new RecaptchaVerifier(
  //       "recaptcha-container2",
  //       { size: "invisible" },
  //       auth
  //     );
  //   }

  //   try {
  //     // 🔹 Run Firebase/Email + WhatsApp OTP in parallel if WhatsApp exists
  //     const requests = [
  //       sendFirebaseOtp(), // handles email + firebase phone OTP
  //     ];
  //     if (form.whatsapp) requests.push(sendWhatsAppOtp());

  //     const results = await Promise.allSettled(requests);

  //     const hasError = results.some(r => r.status === "rejected");
  //     if (hasError) {
  //       const errors = results
  //         .filter(r => r.status === "rejected")
  //         .map(r => r.reason?.message || "Error");
  //       setError(errors.join(" | "));
  //     } else {
  //       setOtpSent(true);
  //       openModal();
  //     }
  //   } catch (err) {
  //     setError(err.message || "Something went wrong");
  //   } finally {
  //     setOtpLoading(false);
  //   }
  // };

  const sendOtp = async (e) => {
    e.preventDefault();
    setOtpLoading(true);
    setError("");

    // Validation
    if (!validatePhoneNumber(form.phone) || !validateEmail(form.email)) {
      setError("Please enter a valid phone and email");
      setOtpLoading(false);
      return;
    }

    // Initialize reCAPTCHA if needed
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container2",
        { size: "invisible" },
        auth
      );
    }

    try {
      // Step 1️⃣: Backend email OTP
      const { data } = await axios.post(`${serverIp}/api/users/requestotp`, {
        email: form.email,
        phone: `+91${form.phone}`,
      });

      if (!data.success){
        throw new Error(data.message || "Email OTP failed");
      } 

      // Step 2️⃣: WhatsApp OTP (optional)
      if (form.whatsapp) {
        await sendWhatsAppOtp();
      }

      // Step 3️⃣: Firebase phone OTP
      const appVerifier = window.recaptchaVerifier;
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        `+91${form.phone}`,
        appVerifier
      );
      window.confirmationResult = confirmationResult;

      // Success
      setOtpSent(true);
      openModal();

    } catch (err) {
      console.log("----->",err);
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setOtpLoading(false);
    }
  };

  // const sendFirebaseOtp = async () => {
  //   // 🔹 Send email OTP
  //   const { data } = await axios.post(`${serverIp}/api/users/requestotp`, {
  //     email: form.email,
  //     phone: `+91${form.phone}`,
  //   });

  //   if (!data.success) throw new Error(data.message || "Email OTP failed");

  //   // 🔹 Send phone OTP via Firebase
  //   const appVerifier = window.recaptchaVerifier;
  //   return signInWithPhoneNumber(auth, `+91${form.phone}`, appVerifier)
  //     .then((confirmationResult) => {
  //       window.confirmationResult = confirmationResult;
  //       return true;
  //     })
  //     .catch((err) => {
  //       throw new Error("Phone OTP failed: " + err.message);
  //     });
  // };

  const sendWhatsAppOtp = async () => {
    if (!validateWhatsappNumber(form.whatsapp)) {
      throw new Error("Invalid WhatsApp number");
    }

    const { data } = await axios.post(`${serverIp}/api/users/send-whatsapp-otp`, {
      phone: form.whatsapp,
    });

    if (!data.success) throw new Error(data.message || "WhatsApp OTP failed");
    return true;
  };


  const verifyOtp = async (e) => {
    e.preventDefault();
    setOtpVerifying(true);
    setError("");

    try {
      // 1️⃣ Verify email + phone OTP
      // await verifyFirebaseOtp();

      if (!form.otpPhone || !form.otpEmail) {
        throw new Error("Please enter both Email & Phone OTP");
      }

      // Verify Email OTP
      const { data } = await axios.post(`${serverIp}/api/users/validateotp`, {
        email: form.email,
        otp: form.otpEmail,
      });

      if (!data.success) throw new Error("Invalid Email OTP");

      // Verify Phone OTP (Firebase)
      const result = await window.confirmationResult.confirm(form.otpPhone);
      const user = result.user;
      const uid = user.uid;
      const token = await user.getIdToken();

      setIdToken(token);
      setUid(uid);


      // 2️⃣ Verify WhatsApp OTP (if entered)
      if (form.whatsapp) {
        await verifyWhatsAppOtp();
      }

      // ✅ Final success → register user
      setOtpVerified(true);
      closeModal(false);
      dispatch(
        register(
          form.firstName,
          form.lastName,
          form.email,
          `+91${form.phone}`,
          form.whatsapp ? `+91${form.whatsapp}` : "",
          true,
          token,
          uid,
          "Web"
        )
      );
    } catch (err) {
      setError(err.message || "OTP verification failed");
      setOtpVerified(false);
    } finally {
      setOtpVerifying(false);
    }
  };

  // const verifyFirebaseOtp = async () => {
  //   if (!form.otpPhone || !form.otpEmail) {
  //     throw new Error("Please enter both Email & Phone OTP");
  //   }

  //   // Verify Email OTP
  //   const { data } = await axios.post(`${serverIp}/api/users/validateotp`, {
  //     email: form.email,
  //     otp: form.otpEmail,
  //   });

  //   if (!data.success) throw new Error("Invalid Email OTP");

  //   // Verify Phone OTP (Firebase)
  //   const result = await window.confirmationResult.confirm(form.otpPhone);
  //   const user = result.user;
  //   const token = await user.getIdToken();

  //   setIdToken(token);
  //   setUid(user.uid);

  //   return true;
  // };

  const verifyWhatsAppOtp = async () => {
    if (!form.otpWhatsapp) throw new Error("Please enter WhatsApp OTP");

    const { data } = await axios.post(`${serverIp}/api/users/verify-whatsapp-otp`, {
      phone: form.whatsapp,
      otp: form.otpWhatsapp,
    });

    if (!data.success) throw new Error("Invalid WhatsApp OTP");

    return true;
  };



  const validateEmail = (mail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(mail)) {
      setEmailError("Please enter a valid email address.");
      return false;
    }
    setEmailError("");
    return true;
  };

  return (
    <div className="flex flex-col md:flex-row border-b justify-between gap-10 px-4 lg:px-8 py-4 bg-white">
      <div className="flex flex-col items-center w-full md:w-1/2 p-4 md:p-10 space-y-8">
        <div className="flex flex-col w-full md:w-[90%]">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-3">
            Create Your Account
          </h2>
          <h3 className="font-semibold text-[14px]">
            Please create your SAIRAH Account.
          </h3>
        </div>
        <form className="mt-8 space-y-6 w-full md:w-[90%]" id="formRegister">
          {errorUSer && <Message type="error">{errorUSer}</Message>}
          {error !== "" && <Message type="error">{error}</Message>}
          <div className="flex flex-col gap-3 -space-y-px rounded-md">
            <div>
              <label htmlFor="firstName" className="text-sm font-[600]">
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={form.firstName}
                onChange={(e) => handleInputChange(e.target.value, "firstName")}
                className="w-full px-4 py-2 border border-gray-300 rounded-md mt-2"
                required
              />
            </div>
            <div>
              <label htmlFor="lastName" className="text-sm font-[600]">
                Last Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={form.lastName}
                onChange={(e) => handleInputChange(e.target.value, "lastName")}
                className="w-full px-4 py-2 border border-gray-300 rounded-md mt-2"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="text-sm font-[600]">
                Email <span className="text-red-500">*</span>
              </label>
              <FormControl isInvalid={emailError}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => {
                    handleInputChange(e.target.value, "email");
                    validateEmail(e.target.value);
                  }}
                  // onBlur={validateEmail}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md mt-2"
                  required
                />
                {emailError && (
                  <FormErrorMessage>{emailError}</FormErrorMessage>
                )}
              </FormControl>
            </div>
            <div>
              <label htmlFor="lastName" className="text-sm font-[600]">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <FormControl isInvalid={phoneError}>
                <InputGroup>
                  <InputLeftAddon px="4" py="5" marginTop={2}>
                    +91
                  </InputLeftAddon>

                  <Input
                    type="tel"
                    placeholder="Phone"
                    value={form.phone}
                    onChange={(e) => {
                      handleInputChange(e.target.value, "phone");
                      validatePhoneNumber(e.target.value);
                    }}
                    maxLength={10}
                    width="full"
                    px="4"
                    py="5"
                    border="1px"
                    borderColor="gray.300"
                    rounded="md"
                    marginTop={2}
                    required
                  />
                </InputGroup>
                {phoneError && (
                  <FormErrorMessage>{phoneError}</FormErrorMessage>
                )}
              </FormControl>
            </div>

            <div>
              <div className="flex items-center mb-1">
                <label htmlFor="whatsapp" className="text-sm font-[600]">
                  WhatsApp Number {" - "}

                  {/* <div className="flex items-center justify-center space-x-2"> */}
                  <input
                    type="checkbox"
                    id="whatsappCheckbox"
                    checked={isSameWhatsApp}
                    onChange={(e) => {
                      setWhatsAppNumber(e.target.checked);
                    }}
                    className="mr-1"
                  />
                  <label htmlFor="whatsappCheckbox" className="text-[14px] font-[500]">
                    Same as Phone Number
                  </label>
                </label>
                {/* </div> */}
              </div>

              <span className="font-normal text-[12px] text-gray-600">
                (Optional — OTP and order details will be sent if provided)
              </span>
              <FormControl isInvalid={whatsappError}>
                {/* <FormControl> */}
                <InputGroup>
                  <InputLeftAddon px="4" py="5" marginTop={2}>
                    <FaWhatsapp className="text-green-500 mr-1" /> +91
                  </InputLeftAddon>

                  <Input
                    type="tel"
                    placeholder="Whatsapp"
                    value={form.whatsapp}
                    onChange={(e) => {
                      handleInputChange(e.target.value, "whatsapp");
                      validateWhatsappNumber(e.target.value);
                    }}
                    maxLength={10}
                    width="full"
                    px="4"
                    py="5"
                    border="1px"
                    borderColor="gray.300"
                    rounded="md"
                    marginTop={2}
                  />
                </InputGroup>
                {whatsappError && (
                  <FormErrorMessage>{whatsappError}</FormErrorMessage>
                )}
              </FormControl>

            </div>

            <Button
              onClick={(e) => sendOtp(e)}
              bgColor="#000080"
              _hover={{ bgColor: "#000090" }}
              color="white"
              w="full"
              py="2"
              isLoading={otpLoading}
              loadingText="Loading..."
              fontSize="sm"
              isDisabled={
                phoneError || emailError || !form.phone || !form.email
              }
            >
              {otpSent ? "Resend OTP" : "Send OTP"}
            </Button>

          </div>
        </form>
        {/* {error && <Message type="error">{error}</Message>} */}
      </div >

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    OTP Validations
                  </Dialog.Title>
                  {error !== "" && <Message type="error">{error}</Message>}
                  <div className="mt-2">
                    <div className="mt-4">
                      <label>Enter Phone OTP</label>
                      <OtpInput
                        value={form.otpPhone}
                        onChange={(value) =>
                          handleInputChange(value, "otpPhone")
                        }
                        OTPLength={6}
                        // autoFocus
                        otpType="number"
                        disabled={false}
                        inputStyles={{
                          width: "100%", // Allows input width to fill container in mobile view
                          maxWidth: "40px", // Sets a maximum width to prevent overflow on larger screens
                          margin: "0 4px", // Simplifies margin for better spacing
                          fontSize: "16px", // Slightly larger for readability
                          textAlign: "center",
                          padding: "4px", // Minimal padding to prevent text clipping
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                        className="opt-container flex w-full justify-center px-2 py-2"
                      />
                    </div>
                    {form.whatsapp && (
                      <div className="mt-4">
                        <label>Enter WhatsApp OTP</label>
                        <OtpInput
                          value={form.otpWhatsapp}
                          onChange={(value) =>
                            handleInputChange(value, "otpWhatsapp")
                          }
                          OTPLength={6}
                          // autoFocus
                          otpType="number"
                          disabled={false}
                          inputStyles={{
                            width: "100%", // Allows input width to fill container in mobile view
                            maxWidth: "40px", // Sets a maximum width to prevent overflow on larger screens
                            margin: "0 4px", // Simplifies margin for better spacing
                            fontSize: "16px", // Slightly larger for readability
                            textAlign: "center",
                            padding: "4px", // Minimal padding to prevent text clipping
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                          className="opt-container flex w-full justify-center px-2 py-2"
                        />
                      </div>
                    )}

                    <div className="mt-4">
                      <label>Enter Email OTP</label>
                      <OtpInput
                        value={form.otpEmail}
                        onChange={(value) =>
                          handleInputChange(value, "otpEmail")
                        }
                        OTPLength={6}
                        // autoFocus
                        otpType="number"
                        disabled={false}
                        inputStyles={{
                          width: "100%", // Allows input width to fill container in mobile view
                          maxWidth: "40px", // Sets a maximum width to prevent overflow on larger screens
                          margin: "0 4px", // Simplifies margin for better spacing
                          fontSize: "16px", // Slightly larger for readability
                          textAlign: "center",
                          padding: "4px", // Minimal padding to prevent text clipping
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                        className="opt-container flex w-full justify-center px-2 py-2"
                      />
                      {/* <button
                        onClick={verifyOtp}
                        className="bg-[#000080] text-white py-2 px-4 rounded-md mt-2 w-full hover:bg-[#000090]"
                      >
                        Verify OTP
                      </button> */}
                      <br />
                      <Button
                        type="button"
                        onClick={verifyOtp}
                        bgColor="#000080"
                        _hover={{ bgColor: "#000090" }}
                        color="white"
                        isLoading={otpVerifying}
                        loadingText="Loading..."
                        w="full"
                        py="2"
                        fontSize="sm"
                      >
                        Verify OTP
                      </Button>

                      {/* ✅ Cancel Button */}
                      <Button
                        type="button"
                        onClick={() => closeModal(false)}
                        variant="outline"
                        w="full"
                        py="2"
                        fontSize="sm"
                        mt="2"
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <div className="flex justify-center items-center">
        <div className="border-b-2 md:border-b-0 border-l-0 md:border-l-2 border-gray-300 w-full md:w-2 h-0 md:h-[500px]"></div>
      </div>

      <div className="flex items-center flex-col w-full md:w-1/2 p-4 md:p-10 space-y-8">
        <div className="flex flex-col gap-4 md:gap-10 w-full md:w-[90%] mb-4">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-3">
            Already have an Account?
          </h2>
          <h3 className="font-semibold text-[14px] leading-10">
            Sign In to access your account, saved items, and order history.
          </h3>
        </div>
        <div className="flex items-center w-full md:w-[90%]">
          <RouterLink
            to="/signup"
            className="flex w-full justify-center rounded-md bg-[#000080] px-3 py-2 text-sm font-semibold text-white hover:bg-[#000090] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Sign In
          </RouterLink>
        </div>
      </div>
    </div >
  );
};

export default RegistrationForm;
